import React, { useContext, useEffect, useState } from 'react'

import DateTimeControl from '@/controls/DateTimeControl'
import { IFieldDateTime } from '@/@types/models/model'
import { Moment } from 'moment'
import Box from '@mui/material/Box'
import Popover from '@mui/material/Popover'
import Button from '@mui/material/Button'
import { DateRange, Filter } from '@mui/icons-material'
import MapContext from '../../MapContext'
import { Tooltip, styled } from '@mui/material'
import makeMUIControlStyle from '../makeMUIControlStyle'
import ButtonControlRoot from './Button/ButtonControlRoot'

import { useTranslation } from 'react-i18next'

const DateRangeControl = () => {

                //tooltip={t("map:controls.date_range_control")}
                //className="ol-date-range-control"

    const mapContext = useContext(MapContext);

    const map = mapContext?.map;

    const { t } = useTranslation();

    const customFieldFrom = {
        source: "date_from",
        title: "Datetime",
        ttoken: "controls.date_from",
        type: "datetime",
        hideHelperText: true
    } as IFieldDateTime

    const customFieldTo = {
        source: "date_to",
        title: "Datetime",
        ttoken: "controls.date_to",
        type: "datetime",
        hideHelperText: true
    } as IFieldDateTime

    const [ready, setReady] = useState(false);

    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    const [dateFromValue, setDateFromValue] = useState<Moment | null>(null)
    const [dateToValue, setDateToValue] = useState<Moment | null>(null)

    const popoverOpen = Boolean(anchorEl);
    const popoverId = popoverOpen ? 'date-range-control-popover' : undefined;

    const handleClickPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClosePopover = () => {
        setAnchorEl(null);
    };

    const changeDateFrom = (newValue: Moment | null, source: string) => {
        setDateFromValue(newValue);
        saveCQLToContext(newValue, true);
    }

    const changeDateTo = (newValue: Moment | null, source: string) => {
        setDateToValue(newValue);
        saveCQLToContext(newValue, false);
    }

    const saveCQLToContext = (newValue: Moment | null, from: boolean) => {

        if (!mapContext) return;

        const attribute = from ? "date_from" : "date_to";

        let newHeatMapCQL = {... mapContext.heatMapCQL};

        newHeatMapCQL[attribute] = newValue ? newValue.format("YYYY-MM-DD") : "";

        mapContext?.setHeatMapCQL(newHeatMapCQL);
    }

    useEffect(() => {
        if (!ready) {
          if (mapContext?.map !== null) {
            setReady(true);
          }
        }
      }, [mapContext?.map]);
    

    return ready ? (
        <>
            <Tooltip title={t("controls.date_range")}> 
                <ButtonControlRoot className='ol-control' id={"date-range-control"} variant="contained" onClick={handleClickPopover} sx={{width: "fit-content", bgcolor: "primary.light", top: "15px", left: "40px"}}>
                    <DateRange/>
                </ButtonControlRoot>
            </Tooltip>
            <Popover
            id={popoverId}
            open={popoverOpen}
            anchorEl={anchorEl}
            onClose={handleClosePopover}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            >
                <Box width={"350px"} display={"flex"} p={1} gap={"10px"}>
                    <DateTimeControl
                        hideTime
                        hideHelperText
                        field={customFieldFrom}
                        formMode='form'
                        value={dateFromValue}
                        controlMode='edit'
                        onChange={changeDateFrom}
                    />

                    <DateTimeControl
                        hideTime
                        hideHelperText
                        field={customFieldTo}
                        formMode='form'
                        value={dateToValue}
                        controlMode='edit'
                        onChange={changeDateTo}
                    />
                </Box>
            </Popover>
        </>
        
    ) : null;
}

const StyledDateRangeControl = styled(DateRangeControl)(({ theme }) => {
    const styles = makeMUIControlStyle(theme);
    return {
      ...styles.control
    }
  })

export default StyledDateRangeControl;